module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selectAGroup"
  }, [(!_vm.groupsAndType) ? _c('i', {
    staticClass: "fa fa-refresh fa-spin grey"
  }) : _vm._e(), _vm._l((_vm.groupsAndType), function(typeAndGroups, key) {
    return _c('section', [_c('div', {
      staticClass: "groupType"
    }, [_c('i', {
      staticClass: "fa",
      class: _vm._f("groupTypeIcon")(key)
    }), _vm._v(" " + _vm._s(_vm.$t('groups.types.' + key))), (typeAndGroups.inactive.length > 0) ? [(_vm.hideInactiveGroupOfType(key)) ? _c('i', {
      staticClass: "fa fa-eye-slash notRecentlyUsedBtn",
      attrs: {
        "title": "Afficher les groupes non utilisés"
      },
      on: {
        "click": function($event) {
          return _vm.toggleShowInactiveGroupOfType(key, $event)
        }
      }
    }) : _vm._e(), (_vm.showInactiveGroupOfType(key)) ? _c('i', {
      staticClass: "fa fa-eye notRecentlyUsedBtn",
      attrs: {
        "title": "Cacher les groupes non utilisés"
      },
      on: {
        "click": function($event) {
          return _vm.toggleShowInactiveGroupOfType(key, $event)
        }
      }
    }) : _vm._e()] : _vm._e()], 2), _c('ul', [_vm._l((typeAndGroups.active), function(group) {
      return _c('li', {
        on: {
          "click": function($event) {
            return _vm.selectGroup(group)
          }
        }
      }, [_c('vue-object-img', {
        attrs: {
          "object": group
        }
      }), _c('div', {
        staticClass: "name"
      }, [_vm._v(" " + _vm._s(group.name))])], 1)
    }), (_vm.showInactiveGroupOfType(key)) ? _vm._l((typeAndGroups.inactive), function(group) {
      return _c('li', {
        on: {
          "click": function($event) {
            return _vm.selectGroup(group)
          }
        }
      }, [_c('vue-object-img', {
        attrs: {
          "object": group
        }
      }), _c('div', {
        staticClass: "name"
      }, [_vm._v(" " + _vm._s(group.name))])], 1)
    }) : [(typeAndGroups.active.length == 0) ? _c('li') : _vm._e()]], 2)])
  }), _c('li', {
    staticClass: "createAGroup",
    on: {
      "click": function($event) {
        return _vm.createGroup()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus grey"
  }), _vm._v(_vm._s(_vm.$t('groups.createAGroup')) + "...")])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f8327ca","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/SelectAGroupDiv.vue
// module id = 995
// module chunks = 1 2